import type { FaireProductEntity } from "../../entity_types/product";

export const p_hzvf9yyd4z: FaireProductEntity = {
  token: "p_hzvf9yyd4z",
  type: "product",
  name: "Droosh Sweet & Sour Mango Chutney",
  brandToken: "b_hbnx2me9hg",
  brandName: "Droosh",
  imageUrl:
    "https://cdn.faire.com/fastly/baa9a226e747cfc386ac7175a84ca87a4ff08d65c4f097912f4921e973c66eda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70647a6c42c5833f95d976a803c3b49b7542eeada6780b79017cba626aec3b53.jpeg",
    "https://cdn.faire.com/fastly/22928e35e4bdc43836ba78f4eaa062dd2ad0cb888c14d7461eb89f2937c0b458.jpeg",
    "https://cdn.faire.com/fastly/e32e97fd01536d3079ce1c24ccc655519be5f09ec67440f145f73b2ed233036b.jpeg",
    "https://cdn.faire.com/fastly/48d133079a184908ca497e2fd57c205403bbc3b9d3b4ac7de53cec13fa5906f2.png",
  ],
  priceDollars: 4,
  description:
    "Tangy Hot Sauce & Cooking Sauce spiced with fresh Mango, Amchur, Chaat Party Spice, Fenugreek, Cumin, and Red Chili. \n\nCraving the nostalgic mango achaar (pickle) flavors of our childhood, our vibrant and tangy hot sauce is crafted with the sweetness of fresh mango and balanced by the tartness of amchur (dried mango powder) for a punchy, sour twist. The Droosh signature Chaat Party Spice adds layers of bold, savory complexity, while earthy fenugreek and cumin provide a warm, aromatic depth. A fiery kick from red chili rounds out the flavor, making this sauce a perfect blend of sweet, sour, and spicy—ideal for cooking or adding a burst of spice and zest to your favorite dishes.\n\n12 calories per bottle \n0 calories per serving\nNon-Gmo\nGluten-Free\nVegan\nNo Artificial Preservatives\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:18.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
